import React, { useState } from "react";
import { toast } from "sonner";
import { Download, Loader2 } from "lucide-react";
import { api, apiError } from "../lib/api";

function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export const Export360PdfButtons = ({ cycleId, employeeName }) => {
  const [busy, setBusy] = useState(null);
  const download = async (version) => {
    setBusy(version);
    try {
      const r = await api.get(`/review-cycles/${cycleId}/export-pdf`, { params: { version }, responseType: "blob" });
      const slug = (employeeName || "employee").toLowerCase().replace(/[^a-z0-9]+/g, "-");
      saveBlob(r.data, `360-${version}-${slug}.pdf`);
    } catch (err) {
      toast.error(apiError(err, "PDF export failed"));
    } finally {
      setBusy(null);
    }
  };
  const Btn = ({ version, label }) => (
    <button onClick={() => download(version)} disabled={!!busy} className="cal-btn cal-btn-ghost text-xs" data-testid={`export-pdf-${version}-btn`}>
      {busy === version ? <Loader2 size={14} className="animate-spin" /> : <Download size={14} />} {label}
    </button>
  );
  return (
    <div className="flex flex-wrap gap-2" data-testid="export-pdf-buttons">
      <Btn version="manager" label="Manager PDF" />
      <Btn version="employee" label="Employee PDF" />
    </div>
  );
};

export default Export360PdfButtons;
